import React from 'react';
import HostUsersPage from './HostUsersPage';

/** Host Room renters page — GET /v1/host/booking-clients/room-renters */
export default function HostRoomRentersPage() {
  return <HostUsersPage variant="room-renters" />;
}
